import {
  Box,
  Button,
  Dialog,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  withStyles
} from "@material-ui/core";
import MyTypography from "@saleor/components/MyTypography";
import { makeStyles } from "@saleor/macaw-ui";
import React, {
  forwardRef,
  ForwardRefRenderFunction,
  useImperativeHandle,
  useState
} from "react";
import { useIntl } from "react-intl";

const useStyle = makeStyles(
  () => ({
    closeButton: {
      width: "178px",
      backgroundColor: "#FF2600",
      borderRadius: "4px",
      alignSelf: "center",
      height: "48px"
    },
    buttonTitle: {
      color: "white",
      fontSize: "18px"
    },
    dialogBox: {
      maxHeight: "calc(100vh - 64px)",
      padding: "32px 24px 32px 24px",
      width: "448px"
    },
    errorMessage: {
      fontSize: "14px",
      fontWeight: 700
    },
    table: {
      marginTop: "8px",
      marginBottom: "32px",
      overflow: "scroll",
      maxWidth: "400px",
      border: "1px solid #E0E0E0",
      borderRadius: "4px",
      "&::-webkit-scrollbar-track": {
        borderRadius: 10
      },
      "&::-webkit-scrollbar-thumb": {
        background: "#CCCCCC",
        borderRadius: 10,
        border: "4px solid #FFFFFF",
        height: "6px"
      },
      "&::-webkit-scrollbar": {
        height: "14px",
        background: "#FFFFFF"
      },
      "& .MuiTableRow-root": {
        "&:hover:not(.MuiTableRow-head):not(.MuiTableRow-footer)": {
          backgroundColor: "#white !important",
          position: "relative"
        },
        "&:nth-child(even)": {
          background: "#EEEEEE",
          "&:hover": {
            backgroundColor: "#EEEEEE !important"
          }
        },
        "&:before": {
          display: "none"
        }
      }
    },
    DialogTitle: {
      fontSize: "20px",
      fontWeight: 700
    },
    record: {
      fontSize: "16px",
      "& span": {
        fontWeight: "bold"
      },
      padding: "24px 0px 24px 0px"
    }
  }),
  { name: "DialogErrorLineExcelUpload" }
);

export interface IRefDialog {
  visible: boolean;
  onOpen: (errors: any) => void;
  onClose: () => void;
}

export interface IError {
  message: string;
  field: string;
}

const DialogErrorLineExcelUpload: ForwardRefRenderFunction<IRefDialog> = (
  _props,
  ref
) => {
  const classes = useStyle();
  const intl = useIntl();
  const [errors, setErrors] = useState<null | IError[]>([]);
  const [visible, setVisible] = useState<boolean>(false);

  const onClose = () => setVisible(false);

  const onOpen = (e: IError[]) => {
    setErrors(e);
    setVisible(true);
  };

  useImperativeHandle(ref, () => ({ onOpen, onClose, visible }));

  const StyledTableHead = withStyles(
    () => ({
      root: {
        "& .MuiTableCell-head": {
          backgroundColor: "#E0E0E0"
        }
      }
    }),
    { name: "StyledTableHead" }
  )(TableHead);

  const table = (
    <TableContainer component={Paper} className={classes.table}>
      <Table>
        <StyledTableHead>
          <TableRow>
            <TableCell>
              <MyTypography variant="subtitle3">Line</MyTypography>
            </TableCell>
            <TableCell align="center">
              <MyTypography variant="subtitle3">Remark</MyTypography>{" "}
            </TableCell>
          </TableRow>
        </StyledTableHead>
        <TableBody>
          {errors.length > 0 &&
            errors.map(row => (
              <TableRow key={row.field}>
                <TableCell
                  component="th"
                  scope="row"
                  style={{ fontWeight: "bold", color: "#222222" }}
                >
                  {row.field}
                </TableCell>
                <TableCell style={{ color: "#222222" }} align="left">
                  <ul>
                    {row.message.split(",").map((message, subIndex) => (
                      <li key={`${row.field}-${subIndex}`}>{message.trim()}</li>
                    ))}
                  </ul>
                </TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>
    </TableContainer>
  );

  return (
    <Dialog
      open={visible}
      keepMounted
      onClose={onClose}
      style={{
        borderRadius: "16px",
        boxShadow: "0px 4px 16px 0px rgba(0, 0, 0, 0.25)"
      }}
    >
      <Box
        className={classes.dialogBox}
        display="flex"
        flexDirection={"column"}
      >
        <Typography className={classes.DialogTitle}>
          {intl.formatMessage({
            defaultMessage: "การอัพโหลดไฟล์ไม่สำเร็จ",
            description: "error"
          })}
        </Typography>
        <Typography className={classes.record}>
          {intl.formatMessage({
            defaultMessage: `ข้อมูลผิดพลาด `,
            description: "records"
          })}
          <span>{errors.length}</span> records
        </Typography>
        <Typography className={classes.errorMessage}>
          {intl.formatMessage({
            defaultMessage: "ข้อมูลเพิ่มเติม",
            description: "info"
          })}
        </Typography>

        {table}
        <Button
          variant="contained"
          color="primary"
          className={classes.closeButton}
          onClick={onClose}
        >
          <Typography className={classes.buttonTitle}>
            {intl.formatMessage({
              defaultMessage: "ปิด",
              description: "close"
            })}
          </Typography>
        </Button>
      </Box>
    </Dialog>
  );
};

export default forwardRef(DialogErrorLineExcelUpload);
